// 防抖
export const debounce = (fn, delay, immediate = false) => {
	let timer = null;
	let calledImmediately = false;

	const debounced = function() {
		const context = this;
		const args = arguments;

		if (immediate) {
			// 如果还没有立即执行过，则立即执行并设置标志
			if (!calledImmediately) {
				fn.apply(context, args);
				calledImmediately = true;
			}
			// 每次调用都清除定时器并重新设置，以重置重置状态的时机
			clearTimeout(timer);
			timer = setTimeout(() => {
				calledImmediately = false;
			}, delay);
		} else {
			// 非立即执行模式
			clearTimeout(timer);
			timer = setTimeout(() => {
				fn.apply(context, args);
			}, delay);
		}
	};

	debounced.cancel = () => {
		clearTimeout(timer);
		timer = null;
		calledImmediately = false;
	};

	return debounced;
};


// 节流
export const throttle = (fn, delay) => {
    // 时间戳
    var timeTwo = 0 //new Date();
    // 定时器
    var timeThree = null;
    return function () {
        let context = this;
        let args = arguments;
        var now = new Date()

        // !!!!时间戳实现【new Date()虽然获取结果不是时间戳但是计算结果会自动转化为时间戳】
        // if(now-timeTwo>=delay){
        //     fn.apply(context,args);
        //     timeTwo=new Date();
        // }

        // !!!!定时器实现
        // if (!timeThree) {
        //     timeThree = setTimeout(function () {
        //         fn.apply(context, args);
        //         timeThree=null;
        //     }, delay)
        // }

        // 结合 ps:最后一次触发在固定频率内会在延迟后触发
        var wait = delay - (now - timeTwo)
        clearTimeout(timeThree)
        if (wait <= 0) {
            fn.apply(context, args);
            timeTwo = new Date();
        } else {
            timeThree = setTimeout(function () {
                fn.apply(context, args);
            }, delay)
        }
    }
}

const viewFileUrl = process.env.VUE_APP_IMG_BASE_URL

// 预览文件地址 - 支持字符串和数组
export function previewFileAddress(url) {
	if (!url) return '';

	const isIncludeProtocol = url.split(':')[0] === 'http' || url.split(':')[0] === 'https';
	if (!isIncludeProtocol) {
		return viewFileUrl + url;
	}
	return url;
}

export function previewFileAddressList(urlList) {
	if (!urlList) return [];

	// 如果是字符串，转换为数组
	const list = Array.isArray(urlList) ? urlList : [urlList];

	return list.map(url => {
		if (!url) return '';
		const isIncludeProtocol = url.split(':')[0] === 'http' || url.split(':')[0] === 'https';
		if (!isIncludeProtocol) {
			return viewFileUrl + url;
		}
		return url;
	}).filter(url => url); // 过滤空值
}